import { useQuery } from '@tanstack/react-query';

import useAppSelector from '~hooks/useAppSelector';
import { isLocked } from '~services/api/calls/entity';
import { selectLockedPageId } from '~store/selectors';

export const usePageLock = (pageId: string) =>
  useQuery({
    queryKey: ['lockPage'],
    queryFn: () => isLocked(pageId),
    enabled: !!pageId,
    refetchInterval: 5000, // Will refetch the lock at given interval in ms
  });

export default function PageLock() {
  const lockedPageId = useAppSelector(selectLockedPageId);
  usePageLock(lockedPageId);
  return null;
}
